"use client";

import { Star, Quote, MapPin, ChevronLeft, ChevronRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import { useRef } from "react";



export default function Testimonials() {

    const testimonials = [
        {
            name: "Ahmed Khan",
            location: "Dubai, UAE",
            image: "https://i.pravatar.cc/150?img=12",
            review:
                "Amazing experience! We found a luxury hotel in Dubai at a much lower price than other booking websites.",
        },
        {
            name: "Sarah Williams",
            location: "London, UK",
            image: "https://i.pravatar.cc/150?img=32",
            review:
                "Booking was smooth and instant. Customer support was incredibly helpful throughout the trip.",
        },
        {
            name: "Mohammed Ali",
            location: "Abu Dhabi, UAE",
            image: "https://i.pravatar.cc/150?img=15",
            review:
                "Excellent hotel deals and verified listings. Highly recommended for UAE travelers.",
        },
        {
            name: "Jessica Brown",
            location: "Manchester, UK",
            image: "https://i.pravatar.cc/150?img=20",
            review:
                "The hotel matched exactly what was shown online. Great prices and a seamless booking process.",
        },
        {
            name: "Ali Hassan",
            location: "Sharjah, UAE",
            image: "https://i.pravatar.cc/150?img=18",
            review:
                "I booked a family staycation through the platform and saved a lot compared to other sites.",
        },
    ];

    const swiperRef = useRef(null);


    return (

        <section
            className="
                py-24
                bg-[#0F766E]
                relative
                overflow-hidden
            "
        >


            {/* Background Decoration */}
            <div
                className="
                    absolute
                    top-0
                    right-0
                    w-96
                    h-96
                    bg-[#D9BB74]
                    opacity-10
                    rounded-full
                    blur-3xl
                "
            />



            <div className="container mx-auto px-6 relative z-10">


                {/* Header */}

                <div className="text-center mb-16">


                    <span
                        className="
                            inline-flex
                            px-5
                            py-2
                            rounded-full
                            bg-[#D9BB74]
                            text-[#1B1B1B]
                            text-sm
                            font-semibold
                            mb-5
                        "
                    >
                        Guest Reviews
                    </span>



                    <h2
                        className="
                            text-4xl
                            font-bold
                            text-white
                            mb-4
                        "
                    >
                        What Travelers Say About Us
                    </h2>



                    <p
                        className="
                            max-w-2xl
                            mx-auto
                            text-white/80
                        "
                    >
                        Thousands of travelers trust us to find
                        the best hotel experiences across UAE.
                    </p>


                </div>

                <div className="flex justify-center lg:justify-end gap-3 mb-8">

                    <button
                        onClick={() => swiperRef.current?.slidePrev()}
                        className="
            group
            w-12
            h-12
            rounded-full
            bg-white/10
            border
            border-white/20
            flex
            items-center
            justify-center
            text-white
            backdrop-blur-md
            transition-all
            duration-300
            hover:bg-[#D9BB74]
            hover:text-[#1B1B1B]
        "
                    >
                        <ChevronLeft
                            size={22}
                            className="
                transition-transform
                duration-300
                group-hover:-translate-x-1
            "
                        />
                    </button>



                    <button
                        onClick={() => swiperRef.current?.slideNext()}
                        className="
            group
            w-12
            h-12
            rounded-full
            bg-[#D9BB74]
            text-[#1B1B1B]
            flex
            items-center
            justify-center
            transition-all
            duration-300
            hover:bg-white
        "
                    >
                        <ChevronRight
                            size={22}
                            className="
                transition-transform
                duration-300
                group-hover:translate-x-1
            "
                        />
                    </button>

                </div>


                <Swiper

                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}

                    modules={[Autoplay, Pagination]}

                    spaceBetween={30}

                    slidesPerView={1}

                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false
                    }}

                    pagination={{
                        clickable: true,
                        el: ".testimonial-pagination",
                    }}

                    breakpoints={{
                        768: {
                            slidesPerView: 2
                        },
                        1024: {
                            slidesPerView: 3
                        }
                    }}

                >


                    {testimonials.map((item, index) => (

                        <SwiperSlide key={index}>


                            <div
                                className="
                                    group
                                    h-full
                                    rounded-3xl
                                    bg-white
                                    dark:bg-[#111827]
                                    p-8
                                    shadow-xl
                                    transition-all
                                    duration-500
                                    hover:-translate-y-2
                                    hover:shadow-2xl
                                "
                            >



                                {/* Quote */}

                                <div
                                    className="
                                        flex
                                        justify-between
                                        items-start
                                        mb-6
                                    "
                                >

                                    <div
                                        className="
                                            w-14
                                            h-14
                                            rounded-2xl
                                            bg-[#D9BB74]
                                            flex
                                            items-center
                                            justify-center
                                        "
                                    >

                                        <Quote
                                            size={28}
                                            className="text-[#1B1B1B]"
                                        />

                                    </div>



                                    <div className="
                                        flex
                                        gap-1
                                    ">

                                        {[...Array(5)].map((_, i) => (

                                            <Star
                                                key={i}
                                                size={16}
                                                fill="#D9BB74"
                                                color="#D9BB74"
                                            />

                                        ))}

                                    </div>


                                </div>




                                <p
                                    className="
                                        text-gray-600
                                        dark:text-gray-300
                                        leading-relaxed
                                        mb-8
                                    "
                                >
                                    "{item.review}"
                                </p>




                                {/* User */}

                                <div
                                    className="
                                        flex
                                        items-center
                                        gap-4
                                        border-t
                                        border-gray-100
                                        dark:border-gray-800
                                        pt-5
                                    "
                                >

                                    <img
                                        src={item.image}
                                        alt={item.name}
                                        className="
                                            w-14
                                            h-14
                                            rounded-full
                                            object-cover
                                            ring-4
                                            ring-[#D9BB74]/30
                                        "
                                    />


                                    <div>

                                        <h4
                                            className="
                                                font-bold
                                                text-gray-900
                                                dark:text-white
                                            "
                                        >
                                            {item.name}
                                        </h4>


                                        <p
                                            className="
                                                flex
                                                items-center
                                                gap-1
                                                text-sm
                                                text-gray-500
                                            "
                                        >

                                            <MapPin size={13} />

                                            {item.location}

                                        </p>

                                    </div>


                                </div>



                            </div>


                        </SwiperSlide>

                    ))}


                </Swiper>

                <div
                    className="
        testimonial-pagination
        flex
        justify-center
        items-center
        gap-3
        mt-10
    "
                ></div>

            </div>


        </section>

    );
}